import { IimAutocompleteFilterable } from '@iim-angular/components';
import { IPurchasingGroupAssignableUserDto } from '../types/purchasing-group-assignable-user.dto';

export class PurchasingGroupAssignableUser implements IimAutocompleteFilterable<PurchasingGroupAssignableUser> {
    public readonly id: string;
    public readonly firstName: string;
    public readonly surName: string;
    public readonly active: boolean;

    constructor(dto: IPurchasingGroupAssignableUserDto) {
        this.id = dto.id;
        this.firstName = dto.firstName;
        this.surName = dto.surName;
        this.active = dto.active;
    }

    public get fullName(): string {
        return `${this.firstName} ${this.surName}`.trim();
    }

    public get value(): PurchasingGroupAssignableUser {
        return this;
    }

    public get valueDisplay(): string {
        if (!this.firstName?.trim()) {
            return this.surName;
        }
        return `${this.surName}, ${this.firstName}`;
    }

    public matches(value: string | IimAutocompleteFilterable<PurchasingGroupAssignableUser>): boolean {
        if (typeof value !== 'string') {
            return this.equals(value);
        }

        const normalizedValue = value.toLowerCase();
        return (
            this.id.toLowerCase().includes(normalizedValue) ||
            this.firstName.toLowerCase().includes(normalizedValue) ||
            this.surName.toLowerCase().includes(normalizedValue) ||
            this.fullName.toLowerCase().includes(normalizedValue)
        );
    }

    public equals(identifier: string | number | IimAutocompleteFilterable<PurchasingGroupAssignableUser>): boolean {
        if (identifier instanceof PurchasingGroupAssignableUser) {
            return identifier.id === this.id;
        }

        return identifier.toString() === this.id;
    }
}
